export default __webpack_public_path__ + "static/media/GE.c8119142.svg";